export default "__VITE_ASSET__f41ca8a6__"